import { CommentBox, Headline2 } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
interface FeedbackCommentBoxProps {
  setComment: (comment: string) => void;
}

export function FeedbackCommentBox({ setComment }: FeedbackCommentBoxProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <Headline2 className="text-base font-normal">{t("feedbackModal.commentTitle")}</Headline2>
      <div className="pt-3 pb-4">
        <CommentBox
          ariaLabel={t("ariaLabels.commentBox")}
          onWritingComment={setComment}
          placeHolderText={t("feedbackModal.commentPlaceHolder")}
        />
      </div>
    </>
  );
}
